export const CHANGE_THEME_TO_DARK = 'CHANGE_THEME_TO_DARK';
export const CHANGE_THEME_TO_LIGHT = 'CHANGE_THEME_TO_LIGHT';
export const CHANGE_THEME_TO_GREEN = 'CHANGE_THEME_TO_GREEN';

export function changeThemeToDark() {
  return {
    type: CHANGE_THEME_TO_DARK,
  };
}

export function changeThemeToLight() {
  return {
    type: CHANGE_THEME_TO_LIGHT,
  };
}
export function changeThemeToGreen() {
  return {
    type: CHANGE_THEME_TO_GREEN,
  };
}